<script lang="ts">
    import { Col, FormGroup, Input, Label, Row } from "sveltestrap";
    import data from "../../../../Data/Project/Project.json"
    import {  Endingdate, ProjectSize, Startingdate } from "../../../../utils/Constant/Constant";
    import ProjectCreateForm from "./ProjectCreateForm.svelte";
</script>
<ProjectCreateForm />
<Row>
    <Col sm="4">
        <FormGroup>
            <Label>{ProjectSize}</Label>
            <Input type="select" class="form-select" name="select" id="exampleSelect" value="Small">
            {#each data.projectsizedata as options }
                <option>{options.option}</option>
            {/each}
            </Input>
        </FormGroup>
    </Col>
    <Col sm="4">
        <FormGroup>
            <Label>{Startingdate}</Label>
            <Input class="datepicker-here" type="text" />
        </FormGroup>
    </Col>
    <Col sm="4">
        <FormGroup>
            <Label>{Endingdate}</Label>
            <Input class="datepicker-here" type="text"/>
        </FormGroup>
    </Col>
</Row>